export function formatCurrency(value: number): string {
  if (!Number.isFinite(value)) return "—";
  if (Math.abs(value) >= 1_000_000) {
    return "£" + (value / 1_000_000).toLocaleString("en-GB", { maximumFractionDigits: 2 }) + "M";
  }
  return value.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
